require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./recipes-utthapamwith-samber.json") })
        }
      }, "path---recipes-utthapamwith-samber");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---recipes-utthapamwith-samber!./.cache/json/recipes-utthapamwith-samber.json
// module id = 743
// module chunks = 231608221292675